<template>
    <AppModal ref="Modal" :title="$t('labels.products_import_modal')" @on-hide="hide">
        <div class="modal-body pb-0">
            <FileComponent ref="File" />
        </div>
        <div class="modal-footer">
            <AppButton color="indigo" :disabled="submitting" @click="importProducts">
                {{ $t('labels.import') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../components/new/modal/AppModal.vue';
import FileComponent from '../../../../../components/form/FileComponent.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';
import { httpClient } from '../../../../../services/HttpClient';
import MessageNotificator from '../../../../../services/MessageNotificator';

export default {
    name: 'ProductsImportModal',
    components: {
        AppModal, FileComponent, AppButton
    },
    emits: ['import:started'],
    data() {
        return {
            submitting: false
        }
    },
    methods: {
        show() {
            this.$refs.Modal.show();
        },
        hide() {
            this.$refs.Modal.hide();
            this.submitting = false;
        },
        async importProducts() {
            const file = this.$refs.File.file;

            if (this.submitting || !file) {
                return;
            }

            this.submitting = true;

            const formData = new FormData();
            formData.append('file', file);

            try {
                await httpClient.post(
                    `/projects/${this.$route.params.projectUuid}/pim/products/import`,
                    formData
                );

                new MessageNotificator().success(this.$t('alerts.import_started'));

                this.$emit('import:started');
                this.hide();
            } catch (e) {
                this.submitting = false;
            }
        }
    }
}
</script>
